import { render, staticRenderFns } from "./NumbersOnEmptyStamp.vue?vue&type=template&id=056297e3&scoped=true&"
import script from "./NumbersOnEmptyStamp.vue?vue&type=script&lang=js&"
export * from "./NumbersOnEmptyStamp.vue?vue&type=script&lang=js&"
import style0 from "./NumbersOnEmptyStamp.vue?vue&type=style&index=0&id=056297e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056297e3",
  null
  
)

export default component.exports